import ErrorIcon from "@mui/icons-material/Error";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

import { colors } from "./colors";
import { stdObject } from "./types/stdObject";

export const iconComp: stdObject = Object.freeze({
  warning: { Comp: ReportProblemIcon, color: colors.orange },
  error: { Comp: ErrorIcon, color: colors.red },
  // loading: { Comp: CircularProgress, color: colors.blue },
  //   logout: { Comp: LogoutIcon, color: colors.red },
});
